import makeService from './api';

export default makeService('nozzles');
